export default {
  selectPlaceHolder1: 'Pleace Select',
  datePlaceHolder1: 'Select date',
  confirm: 'Confirm',
  inputPlaceholder1: 'input here',
  noData: 'No Data',
  noMatch: 'No match',
  success: 'Success!',
  search1: 'Search',
  deleted1: 'Delete',
  defineBtn: 'Confirm',
  edit1: 'Edit',
  notice: 'Notice',
  success2: 'Operation succeeded',
  loading1: 'Loading… ',
  cancel1: 'Cancel',
  update1: 'Update',
  update2: 'Update successful.',
  yes: 'Yes',
  no: 'No',
  region: 'Region',
  reset: 'Reset',
  submit: 'Submit',
  login: 'Login',
  chooseStore: 'Please choose the Store',
  uploadImage: 'upload image',
  upload: 'upload',
  export: 'Export'
}
